import styled from 'styled-components/macro';

export const Main = styled.div.attrs({
  role: 'main',
})`
  position: relative;
  z-index: 1;
  flex: auto;
  background-color: ${({ theme }): string => theme.LightGrey};
  display: grid;
  place-items: center;
`;

export const Box = styled.div<any>`
  margin: 3em 0;
  display: grid;
  place-items: center;
  padding: ${({ isLargeScreen }): string => (isLargeScreen ? '0' : '0 20px')};
`;

export const Divider = styled.hr<any>`
  margin: 2em auto};
  width: ${({ isSmallScreen }): string => (isSmallScreen ? '100%' : '30%')};
`;
